import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import MunicipalTransportationEmissionsPage from './MunicipalTransportationEmissionsPage';

export const ResearchRoutes: React.FC = () => {
  const { pathname } = useLocation();

  if (
    pathname === '/research/municipal-transportation-emissions' ||
    pathname === '/research/municipal-transportation-emissions/'
  ) {
    return <MunicipalTransportationEmissionsPage />;
  }

  return <Navigate to="/" replace />;
};

export default ResearchRoutes;
